import React from "react";
import {
  Accordion,
  Box,
  Button,
  ChevronIcon,
  Flex,
  Group,
  Select,
  SimpleGrid,
  Text,
  TextInput,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

function FieldForm({
  classes,
  view,
  onChanges,
  addFieldRef,
  fieldForm1,
  onSaveField,
  fieldRef,
  fieldTypeOptionsFieldForm,
  arrayOfFieldOptions,
  fieldmultiple,
  othersField,
  fieldError,
  setFieldError,
}) {
  let {
    onChangeFieldsFieldForm,
    handleOtherInputfieldChange,
    handlePriorityFieldChange,
    handleChange,
    handleOptionfieldChange,
  } = onChanges;
  const isMobileScreen = useMediaQuery("(max-width: 600px)");
  return (
    <form onSubmit={fieldForm1?.onSubmit((values) => onSaveField(values))}>
      <>
        {!view && (
          <>
            <Accordion
              key={"field-form"}
              defaultValue={"field-form"}
              variant="separated"
              radius="md"
              mt={15}
            >
              <Accordion.Item
                value={"field-form"}
                className={classes.exicstingFieldTtem}
              >
                <Accordion.Control>
                  <Group position="apart">
                    <Text style={{ fontWeight: 600 }}>
                      {view ? "Field" : "Existing Field"}
                    </Text>
                  </Group>
                </Accordion.Control>
                <Accordion.Panel>
                  <Box>
                    <SimpleGrid cols={isMobileScreen ? 1 : 2}>
                      <Select
                        size="md"
                        searchable
                        ref={fieldRef}
                        placeholder="Field Name"
                        data={arrayOfFieldOptions}
                        {...fieldForm1.getInputProps("field")}
                        onChange={onChangeFieldsFieldForm}
                        disabled={view}
                        radius={"md"}
                        rightSection={
                          <ChevronIcon
                            className={classes.chevron}
                            size="1.5rem"
                            stroke={1.5}
                            style={{
                              opacity: 0.5,
                            }}
                          />
                        }
                      />
                      <Select
                        size="md"
                        onChange={handleChange}
                        placeholder="Field Type"
                        className={classes.myfont}
                        data={fieldTypeOptionsFieldForm}
                        {...fieldForm1.getInputProps("fieldType")}
                        disabled={view}
                        radius={"md"}
                        rightSection={
                          <ChevronIcon
                            className={classes.chevron}
                            size="1.5rem"
                            stroke={1.5}
                            style={{
                              opacity: 0.5,
                            }}
                          />
                        }
                      />
                      <Select
                        size="md"
                        data={["Yes", "No"]}
                        placeholder="Required"
                        className={classes.myfont}
                        {...fieldForm1.getInputProps("priority")}
                        onChange={handlePriorityFieldChange}
                        disabled={view}
                        radius={"md"}
                        rightSection={
                          <ChevronIcon
                            className={classes.chevron}
                            size="1.5rem"
                            stroke={1.5}
                            style={{
                              opacity: 0.5,
                            }}
                          />
                        }
                      />
                      <Select
                        size="md"
                        placeholder="View Only"
                        data={["Yes", "No"]}
                        className={classes.myfont}
                        {...fieldForm1.getInputProps("viewOnly")}
                        disabled={view}
                        radius={"md"}
                        rightSection={
                          <ChevronIcon
                            className={classes.chevron}
                            size="1.5rem"
                            stroke={1.5}
                            style={{
                              opacity: 0.5,
                            }}
                          />
                        }
                      />
                      {fieldmultiple ? (
                        <Select
                          label={"Options"}
                          size="md"
                          placeholder="Field Priority"
                          data={["Facilities", "Clients", "Staff", "Other"]}
                          className={classes.myfont}
                          {...fieldForm1.getInputProps("options")}
                          onChange={handleOptionfieldChange}
                          disabled={view}
                          radius={"md"}
                        />
                      ) : null}
                      {othersField ? (
                        <TextInput
                          size="md"
                          label="Other Options"
                          placeholder="Eg. Option1,Option2,Option3"
                          className={classes.myfont}
                          {...fieldForm1.getInputProps("others")}
                          onChange={handleOtherInputfieldChange}
                          disabled={view}
                        />
                      ) : null}
                    </SimpleGrid>
                    <SimpleGrid
                      cols={2}
                      className={classes.mwd}
                      sx={{
                        paddingTop: 10,
                      }}
                    ></SimpleGrid>
                  </Box>
                  <Flex
                    justify="flex-end"
                    align="center"
                    direction="row"
                    gap={"1rem"}
                    mt={"1rem"}
                  >
                    {!view && (
                      <Button
                        size="md"
                        radius="md"
                        color="gray"
                        type="submit"
                        ref={addFieldRef}
                      >
                        Add
                      </Button>
                    )}
                  </Flex>
                  {/* <Box>
                    <ActionIcon
                      color="blue"
                      variant="light"
                      mt={5}
                      size={44}
                      onClick={() => {
                        setFieldError("");
                        fieldForm1.setValues({
                          field: "",
                          priority: "",
                          fieldType: "",
                        });
                      }}
                    >
                      <Icon360 />
                    </ActionIcon>
                  </Box> */}
                </Accordion.Panel>
              </Accordion.Item>
            </Accordion>
          </>
        )}
        {fieldError != "" ? (
          <p style={{ color: "red", margin: 0, padding: 0 }}>{fieldError}</p>
        ) : (
          ""
        )}
      </>
    </form>
  );
}

export default FieldForm;
